import React from 'react';
import reactDom from '../../../../common/react/dom/index';
// import Cart from '../../../components/frontend/cart';
import Register from '../../../../components/frontend/account/register';

export default function init() {
	reactDom(<Register />, 'js-react-register');
}
